<div class="ks3-page">

  <!-- ============================================================
       HERO
       ============================================================ -->
  <section class="ks3-hero">
    <div class="ks3-hero-blob ks3-hero-blob--1"></div>
    <div class="ks3-hero-blob ks3-hero-blob--2"></div>
    <div class="ks3-container">
      <div class="ks3-hero-inner">

        <!-- LEFT -->
        <div class="ks3-hero-left">
          <div class="ks3-hero-badge">
            <span class="ks3-badge-pulse"></span>
            Real Exam Practice · KS3
          </div>
          <h1 class="ks3-hero-title">
            KS3 Mock Tests<br>
            <em>Real Exam Practice</em>
          </h1>
          <p class="ks3-hero-sub">8 centres across England · Year 7, 8 &amp; 9 · Full-length exam conditions · Detailed personalised feedback · National Curriculum aligned papers</p>

          <div class="ks3-hero-actions">
            <button class="ks3-btn-primary" (click)="scrollToCalendar()">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Start Booking Now
            </button>
            <button class="ks3-btn-ghost" (click)="downloadSchedule()">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              Download Schedule
            </button>
          </div>

          <div class="ks3-hero-stats">
            <div class="ks3-hstat"><strong>8</strong><span>Centres</span></div>
            <div class="ks3-hstat-div"></div>
            <div class="ks3-hstat"><strong>6</strong><span>Subjects</span></div>
            <div class="ks3-hstat-div"></div>
            <div class="ks3-hstat"><strong>5K+</strong><span>Students</span></div>
            <div class="ks3-hstat-div"></div>
            <div class="ks3-hstat"><strong>Year 7 · 8 · 9</strong><span>Year Groups</span></div>
          </div>

          <ul class="ks3-hero-checklist">
            <li>
              <span class="ks3-ck"><svg width="9" height="9" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="white" stroke-width="1.8" stroke-linecap="round"/></svg></span>
              Face-to-face mock conditions
            </li>
            <li>
              <span class="ks3-ck"><svg width="9" height="9" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="white" stroke-width="1.8" stroke-linecap="round"/></svg></span>
              Instant Feedback Report
            </li>
            <li>
              <span class="ks3-ck"><svg width="9" height="9" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="white" stroke-width="1.8" stroke-linecap="round"/></svg></span>
              National Curriculum aligned papers
            </li>
            <li>
              <span class="ks3-ck"><svg width="9" height="9" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="white" stroke-width="1.8" stroke-linecap="round"/></svg></span>
              Expert 1-to-1 review included
            </li>
            <li>
              <span class="ks3-ck"><svg width="9" height="9" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="white" stroke-width="1.8" stroke-linecap="round"/></svg></span>
              E-results same day
            </li>
          </ul>
        </div>

        <!-- RIGHT — quick guide card -->
        <div class="ks3-hero-right">
          <div class="ks3-hero-guide">
            <div class="ks3-guide-title">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              How to Book in 3 Steps
            </div>
            <div class="ks3-guide-steps">
              <div class="ks3-gstep">
                <div class="ks3-gstep-num">1</div>
                <div>
                  <div class="ks3-gstep-label">Choose your year group</div>
                  <div class="ks3-gstep-sub">Year 7, Year 8 or Year 9</div>
                </div>
              </div>
              <div class="ks3-gstep">
                <div class="ks3-gstep-num">2</div>
                <div>
                  <div class="ks3-gstep-label">Pick your centre &amp; date</div>
                  <div class="ks3-gstep-sub">Filter by location and year group below</div>
                </div>
              </div>
              <div class="ks3-gstep">
                <div class="ks3-gstep-num">3</div>
                <div>
                  <div class="ks3-gstep-label">Click Book Now</div>
                  <div class="ks3-gstep-sub">Takes 60 seconds to complete</div>
                </div>
              </div>
            </div>
            <div class="ks3-guide-highlights">
              <div class="ks3-guide-hl">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                Maths · English · Science subjects
              </div>
              <div class="ks3-guide-hl">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                Result Analysis Report + doubt-clearing included
              </div>
              <div class="ks3-guide-hl">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                E-results delivered same day
              </div>
            </div>
            <button class="ks3-guide-cta" (click)="scrollToCalendar()">
              View All Sessions →
            </button>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       BOOKING INFO CARD
       ============================================================ -->
  <section class="ks3-section ks3-booking-section">
    <div class="ks3-container">
      <p class="ks3-eyebrow" style="justify-content:center;display:flex">Book Your Session</p>
      <h2 class="ks3-section-title" style="text-align:center">KS3 Mock Test <span>Booking</span></h2>
      <p class="ks3-section-sub" style="text-align:center;margin:0 auto 40px">Full-length exam-condition mock tests with subject-specific feedback. Choose your centre, select a date, and confirm your session.</p>

      <div class="ks3-booking-card">
        <div class="ks3-booking-icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 12h6M9 16h4"/></svg>
        </div>
        <div class="ks3-booking-body">
          <h3>KS3 Mock Test</h3>
          <p>Available in Maths, English Language, English Literature, Science, Verbal Reasoning and Non-Verbal Reasoning. Full-length mock under timed exam conditions. Includes Result Analysis Report, doubt-clearing session, take-home past papers and personalised feedback.</p>
          <ul class="ks3-tick-list">
            <li><span class="ks3-tk"><svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="#0B4F6C" stroke-width="1.6" stroke-linecap="round"/></svg></span>All 3 year groups – Year 7, 8 &amp; 9</li>
            <li><span class="ks3-tk"><svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="#0B4F6C" stroke-width="1.6" stroke-linecap="round"/></svg></span>8 centres across England</li>
            <li><span class="ks3-tk"><svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="#0B4F6C" stroke-width="1.6" stroke-linecap="round"/></svg></span>E-results delivered same day</li>
            <li><span class="ks3-tk"><svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="#0B4F6C" stroke-width="1.6" stroke-linecap="round"/></svg></span>Result Analysis Report + doubt-clearing session included</li>
          </ul>
          <button class="ks3-btn-primary" (click)="scrollToCalendar()">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            View All Sessions
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       CENTRES
       ============================================================ -->
  <section class="ks3-section ks3-centres-section">
    <div class="ks3-container">
      <p class="ks3-eyebrow" style="justify-content:center;display:flex">Pick Your Centre</p>
      <h2 class="ks3-section-title" style="text-align:center">8 Centres <span>Across England</span></h2>
      <div class="ks3-centres-grid">
        <a class="ks3-centre-card" (click)="filterByCentre('Ilford')">
          <span class="ks3-centre-region">London</span>
          <span class="ks3-centre-name">Ilford</span>
          <span class="ks3-centre-boards">Year 7 · 8 · 9</span>
          <span class="ks3-centre-arrow">→</span>
        </a>
        <a class="ks3-centre-card" (click)="filterByCentre('Chelmsford')">
          <span class="ks3-centre-region">Essex</span>
          <span class="ks3-centre-name">Chelmsford</span>
          <span class="ks3-centre-boards">Year 7 · 8 · 9</span>
          <span class="ks3-centre-arrow">→</span>
        </a>
        <a class="ks3-centre-card" (click)="filterByCentre('Redbridge')">
          <span class="ks3-centre-region">London</span>
          <span class="ks3-centre-name">Redbridge</span>
          <span class="ks3-centre-boards">Year 7 · 8 · 9</span>
          <span class="ks3-centre-arrow">→</span>
        </a>
        <a class="ks3-centre-card" (click)="filterByCentre('Southend')">
          <span class="ks3-centre-region">Essex</span>
          <span class="ks3-centre-name">Southend</span>
          <span class="ks3-centre-boards">Year 7 · 8 · 9</span>
          <span class="ks3-centre-arrow">→</span>
        </a>
        <a class="ks3-centre-card" (click)="filterByCentre('Bexley')">
          <span class="ks3-centre-region">Kent</span>
          <span class="ks3-centre-name">Bexley</span>
          <span class="ks3-centre-boards">Year 7 · 8 · 9</span>
          <span class="ks3-centre-arrow">→</span>
        </a>
        <a class="ks3-centre-card" (click)="filterByCentre('Amersham')">
          <span class="ks3-centre-region">Bucks</span>
          <span class="ks3-centre-name">Amersham</span>
          <span class="ks3-centre-boards">Year 7 · 8 · 9</span>
          <span class="ks3-centre-arrow">→</span>
        </a>
        <a class="ks3-centre-card" (click)="filterByCentre('Milton Keynes')">
          <span class="ks3-centre-region">Bucks</span>
          <span class="ks3-centre-name">Milton Keynes</span>
          <span class="ks3-centre-boards">Year 7 · 8 · 9</span>
          <span class="ks3-centre-arrow">→</span>
        </a>
        <a class="ks3-centre-card" (click)="filterByCentre('Harrow')">
          <span class="ks3-centre-region">London</span>
          <span class="ks3-centre-name">Harrow</span>
          <span class="ks3-centre-boards">Year 7 · 8 · 9</span>
          <span class="ks3-centre-arrow">→</span>
        </a>
      </div>
    </div>
  </section>

  <!-- ============================================================
       CALENDAR HEADING
       ============================================================ -->
  <div class="ks3-cal-heading" id="calendar-section">
    <div class="ks3-container">
      <p class="ks3-eyebrow" style="justify-content:center;display:flex">Step 2 — Book Your Session</p>
      <h2 class="ks3-section-title ks3-section-title--light" style="text-align:center">Mock Test <span>Schedule</span></h2>
      <p style="text-align:center;font-size:15px;color:rgba(255,255,255,.52);margin-top:8px">
        Use the filters to narrow results, then click the gold <strong style="color:var(--ks3-g)">Book Now →</strong> button
      </p>
    </div>
  </div>

  <!-- STICKY FILTER BAR -->
  <div class="ks3-filterbar">
    <div class="ks3-filterbar-main">
      <div class="ks3-container">
        <div class="ks3-filters-row">

          <!-- Search -->
          <div class="ks3-fg ks3-fg--search">
            <label class="ks3-flabel">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>
              Search
            </label>
            <input type="text" class="ks3-finput"
                   placeholder="Subject, centre, year group..."
                   [(ngModel)]="filters.search" (input)="applyFilters()" />
          </div>

          <!-- Centre -->
          <div class="ks3-fg">
            <label class="ks3-flabel">Centre</label>
            <select class="ks3-fselect" [(ngModel)]="filters.center" (change)="applyFilters()">
              <option [ngValue]="null">Any Centre</option>
              <option *ngFor="let c of centers" [ngValue]="c">{{ c }}</option>
            </select>
          </div>

          <!-- Year Group -->
          <div class="ks3-fg">
            <label class="ks3-flabel">Year Group</label>
            <select class="ks3-fselect" [(ngModel)]="filters.categoryId" (change)="applyFilters()">
              <option [ngValue]="null">All Year Groups</option>
              <option *ngFor="let c of ks3Categories" [ngValue]="c.category_id">{{ getYearGroupLabel(c.category_id) }}</option>
            </select>
          </div>

          <!-- Mode toggle -->
          <div class="ks3-fg ks3-fg--mode">
            <label class="ks3-flabel">Mode</label>
            <div class="ks3-mode-toggle">
              <button class="ks3-mode-btn ks3-mode-btn--f2f"
                      [class.ks3-mode-btn--active]="filters.mode === 'Classroom Session'"
                      (click)="setMode('Classroom Session')">
                <span class="ks3-mode-dot"></span> Face to Face
              </button>
              <button class="ks3-mode-btn ks3-mode-btn--online"
                      [class.ks3-mode-btn--active]="filters.mode === 'Online Session'"
                      (click)="setMode('Online Session')">
                <span class="ks3-mode-dot"></span> Online
              </button>
              <button class="ks3-mode-btn ks3-mode-btn--all"
                      [class.ks3-mode-btn--active]="!filters.mode"
                      (click)="setMode(null)">
                All
              </button>
            </div>
          </div>

          <!-- Reset -->
          <button class="ks3-freset" (click)="resetFilters()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            Reset
          </button>

          <!-- Offers -->
          <a class="ks3-foffers" [routerLink]="['/offer-free-resources']">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><path d="M12 22V7"/></svg>
            Offers
          </a>

        </div>
      </div>
    </div>

    <!-- Active pills -->
    <div class="ks3-filterbar-pills" *ngIf="filters.categoryId || filters.mode || filters.center || filters.search">
      <div class="ks3-container">
        <div class="ks3-pills-row">
          <span class="ks3-pills-label">Active filters:</span>
          <span class="ks3-pill" *ngIf="filters.categoryId">
            {{ getYearGroupLabel(filters.categoryId) }} <button class="ks3-pill-x" (click)="filters.categoryId=null;applyFilters()">✕</button>
          </span>
          <span class="ks3-pill" *ngIf="filters.mode">
            {{ filters.mode === 'Online Session' ? 'Online' : 'Face to Face' }}
            <button class="ks3-pill-x" (click)="setMode(null)">✕</button>
          </span>
          <span class="ks3-pill" *ngIf="filters.center">
            {{ filters.center }} <button class="ks3-pill-x" (click)="filters.center=null;applyFilters()">✕</button>
          </span>
          <span class="ks3-pill" *ngIf="filters.search">
            "{{ filters.search }}" <button class="ks3-pill-x" (click)="filters.search='';applyFilters()">✕</button>
          </span>
          <span class="ks3-count">{{ testList?.length || 0 }} session{{ testList?.length !== 1 ? 's' : '' }} found</span>
        </div>
      </div>
    </div>
  </div>

  <!-- SESSION LIST -->
  <section class="ks3-sessions">
    <div class="ks3-container">

      <div class="ks3-sortbar">
        <span class="ks3-sortbar-count" *ngIf="testList?.length > 0">
          Showing <strong>{{ testList.length }}</strong> session{{ testList.length !== 1 ? 's' : '' }}
        </span>
        <div class="ks3-sortbar-right">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="21" y1="10" x2="3" y2="10"/><line x1="21" y1="6" x2="3" y2="6"/><line x1="21" y1="14" x2="3" y2="14"/><line x1="21" y1="18" x2="3" y2="18"/></svg>
          Sorted by date (earliest first)
        </div>
      </div>

      <ng-container *ngIf="testList && testList.length > 0; else ks3Empty">

        <div class="ks3-scard" *ngFor="let t of testList" [class.ks3-scard--range]="isRangeDate(t.test_date)">

          <span style="display:none">{{ t.test_name }} {{ t.course }} {{ t.category }} {{ t.type }} {{ t.all_location || t.location }}</span>

          <!-- Date -->
          <div class="ks3-scard-date" [class.ks3-scard-date--range]="isRangeDate(t.test_date)" [class.ks3-scard-date--tbd]="!hasDate(t.test_date)">
            <ng-container *ngIf="hasDate(t.test_date); else noDate">
              <span class="ks3-scard-from" *ngIf="isRangeDate(t.test_date)">From</span>
              <span class="ks3-scard-day">{{ getDateDay(t.test_date) }}</span>
              <span class="ks3-scard-mon">{{ getDateMon(t.test_date) }}</span>
              <span class="ks3-scard-yr">{{ getDateYr(t.test_date) }}</span>
            </ng-container>
            <ng-template #noDate>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="opacity:.55"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              <span class="ks3-scard-tbd">TBC</span>
            </ng-template>
          </div>

          <!-- Info -->
          <div class="ks3-scard-info">
            <div class="ks3-scard-top">
              <a class="ks3-scard-cat" [routerLink]="['/ks3-mock-test/category/', t.category_slug, t.test_slug]">
                {{ getYearGroupLabel(t.category_id) || trimChar(t.category) }}
              </a>
              <span class="ks3-scard-mode" [class.ks3-scard-mode--online]="t.exam_type === 'Online Session'" [class.ks3-scard-mode--f2f]="t.exam_type !== 'Online Session'">
                <span class="ks3-mode-dot-sm"></span>
                {{ t.exam_type === 'Online Session' ? 'Online' : 'Face to Face' }}
              </span>
              <!-- Subject tag -->
              <span class="ks3-scard-subject-tag" *ngIf="getSubjectTag(t.test_name) as tag" [ngClass]="'ks3-tag--' + tag.cls">{{ tag.label }}</span>
            </div>
            <a class="ks3-scard-type" [routerLink]="['/ks3-mock-test/category/', t.category_slug, t.test_slug]">{{ trimChar(t.type) }}</a>
            <a class="ks3-scard-name" [routerLink]="['/ks3-mock-test/category/', t.category_slug, t.test_slug]">{{ t.test_name }}</a>
            <div class="ks3-scard-loc" *ngIf="t.location || t.all_location">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
              {{ trimChar(t.all_location || t.location) }}
            </div>
          </div>

          <!-- Price -->
          <div class="ks3-scard-price">
            <ng-container *ngIf="t.payment_method === 'Free'; else priced">
              <span class="ks3-price-free">Free</span>
            </ng-container>
            <ng-template #priced>
              <span class="ks3-price-val">£{{ t.test_fees }}</span>
              <span class="ks3-price-lbl">per student</span>
            </ng-template>
          </div>

          <!-- Book -->
          <div class="ks3-scard-book">
            <a class="ks3-book-btn" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Book Now
            </a>
          </div>

        </div>

        <div class="ks3-loadmore">
          <button class="ks3-loadmore-btn" (click)="loadMore()">Load More Sessions</button>
        </div>

      </ng-container>

      <ng-template #ks3Empty>
        <div class="ks3-empty">
          <div class="ks3-empty-ico">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>
          </div>
          <h3 class="ks3-empty-title">No sessions match your filters</h3>
          <p class="ks3-empty-sub">Try widening your search or removing some filters</p>
          <button class="ks3-empty-reset" (click)="resetFilters()">Clear All Filters</button>
        </div>
      </ng-template>

    </div>
  </section>

  <!-- ============================================================
       PATHWAY
       ============================================================ -->
  <div class="ks3-pathway">
    <div class="ks3-container">
      <p class="ks3-pathway-label">Examination Preparation Pathway</p>
      <div class="ks3-pathway-inner">
        <div class="ks3-pstep">
          <div class="ks3-pstep-ico">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 12h6M9 16h4"/></svg>
          </div>
          <div class="ks3-pstep-text"><strong>Topic Tests</strong><span>Build foundations</span></div>
        </div>
        <div class="ks3-parrow">→</div>
        <div class="ks3-pstep">
          <div class="ks3-pstep-ico">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
          </div>
          <div class="ks3-pstep-text"><strong>Sprint Papers</strong><span>Build speed</span></div>
        </div>
        <div class="ks3-parrow">→</div>
        <div class="ks3-pstep">
          <div class="ks3-pstep-ico">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
          </div>
          <div class="ks3-pstep-text"><strong>Full Mock Papers</strong><span>Real conditions</span></div>
        </div>
        <div class="ks3-parrow">→</div>
        <div class="ks3-pstep ks3-pstep--goal">
          <div class="ks3-pstep-ico ks3-pstep-ico--gold">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>
          </div>
          <div class="ks3-pstep-text"><strong>School Assessments</strong><span>The goal!</span></div>
        </div>
      </div>
    </div>
  </div>

  <!-- ============================================================
       WHY CHOOSE US
       ============================================================ -->
  <section class="ks3-section ks3-why-section">
    <div class="ks3-container">
      <p class="ks3-eyebrow" style="justify-content:center;display:flex">Best Choice</p>
      <h2 class="ks3-section-title ks3-section-title--light" style="text-align:center">Mock Tests That <span>Make a Difference</span></h2>
      <p class="ks3-section-sub ks3-section-sub--light" style="text-align:center;margin:0 auto 44px">Trusted by 5,000+ KS3 students and their families across England.</p>
      <div class="ks3-why-grid">
        <div class="ks3-why-card" *ngFor="let w of whyCards">
          <div class="ks3-why-icon" [innerHTML]="w.icon"></div>
          <h4>{{ w.title }}</h4>
          <p>{{ w.text }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       EVERYTHING INCLUDED
       ============================================================ -->
  <section class="ks3-section ks3-included-section">
    <div class="ks3-container">
      <p class="ks3-eyebrow" style="justify-content:center;display:flex">Comprehensive Support</p>
      <h2 class="ks3-section-title" style="text-align:center">Everything <span>Included</span> In Every Mock</h2>
      <div class="ks3-included-layout">
        <div class="ks3-included-list">
          <div class="ks3-included-item" *ngFor="let f of features">
            <div class="ks3-inc-icon" [innerHTML]="f.icon"></div>
            <div>
              <h4>{{ f.title }}</h4>
              <p>{{ f.text }}</p>
            </div>
          </div>
        </div>
        <div class="ks3-package-card">
          <h3>Mock Test Package</h3>
          <p>Everything your child needs to perform at their best on assessment day.</p>
          <div class="ks3-pkg-stats">
            <div class="ks3-pkg-stat"><strong>6+</strong><span>Past Papers</span></div>
            <div class="ks3-pkg-stat"><strong>100%</strong><span>Conditions</span></div>
            <div class="ks3-pkg-stat"><strong>1:1</strong><span>Feedback</span></div>
          </div>
          <button class="ks3-pkg-cta" (click)="scrollToCalendar()">Book Your Session</button>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       TESTIMONIALS
       ============================================================ -->
  <section class="ks3-section ks3-testi-section">
    <div class="ks3-container">
      <p class="ks3-eyebrow" style="justify-content:center;display:flex">5,000+ Happy Students</p>
      <h2 class="ks3-section-title" style="text-align:center">What <span>Parents Say</span></h2>
      <div class="ks3-testi-grid">
        <div class="ks3-tcard" *ngFor="let t of testimonials">
          <div class="ks3-tcard-quote">"</div>
          <div class="ks3-tcard-stars">★★★★★</div>
          <p class="ks3-tcard-text">{{ t.text }}</p>
          <div class="ks3-tcard-author">{{ t.name }} <span>· {{ t.location }}</span></div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       FAQ
       ============================================================ -->
  <section class="ks3-section ks3-faq-section">
    <div class="ks3-container">
      <p class="ks3-eyebrow" style="justify-content:center;display:flex">Got Questions?</p>
      <h2 class="ks3-section-title" style="text-align:center">Frequently <span>Asked</span> Questions</h2>
      <div class="ks3-faq-list">
        <div class="ks3-faq-item" *ngFor="let f of faqs; let i = index" [class.ks3-faq-item--open]="openFaq === i">
          <button class="ks3-faq-q" (click)="toggleFaq(i)">
            {{ f.q }}
            <svg class="ks3-faq-chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
          <div class="ks3-faq-a">{{ f.a }}</div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       CONTACT
       ============================================================ -->
  <div class="ks3-contact">
    <div class="ks3-container">
      <div class="ks3-contact-inner">
        <p class="ks3-contact-title">Still have questions? We're here to help.</p>
        <div class="ks3-contact-links">
          <a href="tel:+447464772331" class="ks3-contact-link">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.36 2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.84a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.03z"/></svg>
            +44 7464 772331
          </a>
          <a href="mailto:academy@sehyog.co.uk" class="ks3-contact-link">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            academy@sehyog.co.uk
          </a>
        </div>
      </div>
    </div>
  </div>

</div>